import { States } from 'safe'
import {
  SET_DEALERS,
  SET_DEALER,
  UPDATE_DEALER,
  DELETE_DEALER,
  DealerTypes,
  ENABLE_DEALER,
  DELETE_DOCUMENT,
  ADD_DOCUMENT,
} from '../actions/actionTypes'

const initialState: States.Dealer = {
  dealers: [],
  numberOfPages: 0,
}

//eslint-disable-next-line
export default (state = initialState, action: DealerTypes): States.Dealer => {
  let _dealers, index
  console.log('VER', action)
  switch (action.type) {
    case SET_DEALERS:
      return {
        ...state,
        dealers: action.payload.providers,
        numberOfPages: action.payload.numberOfPages,
      }

    case SET_DEALER:
      return { ...state, dealers: [...state.dealers, action.payload] }

    case UPDATE_DEALER:
      _dealers = [...state.dealers]
      index = _dealers.findIndex((i) => i.id === action.payload.id)
      _dealers[index] = { ..._dealers[index], ...action.payload }
      return { ...state, dealers: _dealers }

    case ENABLE_DEALER:
      _dealers = [...state.dealers]
      index = _dealers.findIndex((i) => i.id === action.payload.id)
      _dealers[index] = {
        ..._dealers[index],
        enable: action.payload.enable,
      }
      return { ...state, dealers: _dealers }

    case DELETE_DEALER:
      _dealers = [...state.dealers]
      index = _dealers.findIndex((i) => i.id === action.payload.id)
      _dealers.splice(index, 1)
      return { ...state, dealers: _dealers }
    case DELETE_DOCUMENT:
      _dealers = [...state.dealers]
      index = _dealers.findIndex((i) => i.id === action.payload.providerId)
      _dealers[index].documents = _dealers[index].documents.filter(
        (document) => document.id !== action.payload.documentId
      )
      return { ...state, dealers: _dealers }
    case ADD_DOCUMENT:
      _dealers = [...state.dealers]
      index = _dealers.findIndex((i) => i.id === action.payload.providerId)
      _dealers[index].documents.push({
        id: action.payload.document.id,
        provider: action.payload.providerId,
        url: action.payload.document.url,
      })
      return { ...state, dealers: _dealers }
    default:
      return state
  }
}
